import { render, staticRenderFns } from "./HeaderBreadcrumbsTablet.vue?vue&type=template&id=2989adf7&scoped=true&"
import script from "./HeaderBreadcrumbsTablet.vue?vue&type=script&lang=js&"
export * from "./HeaderBreadcrumbsTablet.vue?vue&type=script&lang=js&"
import style0 from "./HeaderBreadcrumbsTablet.vue?vue&type=style&index=0&id=2989adf7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2989adf7",
  null
  
)

export default component.exports